<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Add Child Profile"
    seFeDataSubtitle="Add a child profile"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for Child Contact profile inputs</p>
      </se-fe-card-content>
    </se-fe-card>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Add Child Profile Info Example"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-add-child-profile-example></se-po-add-child-profile-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for Child Contact Info inputs</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="AddChildContactInfoComponent"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="addChildContactInfoComponent">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="Add Child Contact Info Example"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-add-child-contact-info-example></se-po-add-child-contact-info-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
